export default __webpack_public_path__ + "static/media/V_Vaca.bcd49fc0.mp3";